<template>
  <div v-loading="loading" class="edit-ambassador-container">
    <div class="header-container">
      {{ $t(`${i18nPrefix}.label.${ isEditMode ? 'editAmbassador' : 'addAmbassador'}`) }}
    </div>
    <div class="ambassador-info">
      <div class="body-container">
        <WrappedForm
          ref="ambassadorInfoFormRef"
          labelWidth="150px"
          :model="ambassador"
          :formLines="formLines"
        >
        </WrappedForm>
      </div>
      <div class="btn-container">
        <el-button @click="handelCancel">{{ $t(`${i18nPrefix}.btn.cancelUpload`) }}</el-button>
        <el-button type="primary" @click="handelSave">{{ $t(`${i18nPrefix}.btn.ConfirmUpload`) }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import { emailRegexp } from '@/utils/validator'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedForm
  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobPoster',
      loading: false,
      ambassador: {
        email: null,
        phone: null,
        name: null
      }
    }
  },
  computed: {
    formLines () {
      const lines = {
        email: {
          disabled: this.isEditMode,
          label: this.$t(`${this.i18nPrefix}.label.email`),
          rules: [{ validator: this.validateEmail, trigger: 'blur' }]
        },
        phone: {
          disabled: this.isEditMode,
          label: this.$t(`${this.i18nPrefix}.label.phone`),
          rules: [{ validator: this.validatePhone, trigger: 'blur' }]
        },
        name: {
          label: this.$t(`${this.i18nPrefix}.label.name`)
        }
      }
      return lines
    },
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    ambassadorId () {
      return this.$route.params.ambassadorId
    }
  },
  created () {
    if (this.isEditMode && this.ambassadorId) {
      this.initData()
    }
  },
  methods: {
    ...mapActions('jobPosterAmbassador', ['getJobPosterAmbassadorById', 'addJobPosterAmbassador', 'updateJobPosterAmbassador']),
    async initData () {
      this.loading = true
      try {
        const resp = await this.getJobPosterAmbassadorById(this.ambassadorId)
        if (resp) {
          this.ambassador.email = resp.email_address
          this.ambassador.phone = resp.phone
          this.ambassador.name = resp.name
        }
      } finally {
        this.loading = false
      }
    },
    validateEmail (rule, value, callback) {
      if (this.isEditMode) {
        callback()
      }
      let errorMsg = null
      if ((!value && !this.ambassador.phone) || (value && !emailRegexp.test(value))) {
        errorMsg = this.$t('common.message.invalidEmail')
      }
      if (errorMsg) {
        callback(new Error(errorMsg))
      } else {
        callback()
      }
    },
    validatePhone (rule, value, callback) {
      if (this.isEditMode) {
        callback()
      }
      let errorMsg = null
      if ((!value && !this.ambassador.email) || (value && !/^(\+)*(0)*(86)*1(\d){10}$/.test(value))) {
        errorMsg = this.$t('common.message.invalidMobile')
      }
      if (errorMsg) {
        callback(new Error(errorMsg))
      } else {
        callback()
      }
    },
    handelCancel () {
      const backUrl = this.$route.query.back
      if (backUrl) {
        mixedRouterPush(this.$route.query.back)
      } else {
        this.$router.go(-1)
      }
    },
    async handelSave () {
      const isValidate = await this.$refs.ambassadorInfoFormRef.submit()
      if (!isValidate) {
        return
      }
      const ambassador = this.ambassador
      const saveMethod = this.isEditMode ? this.updateJobPosterAmbassador : this.addJobPosterAmbassador
      const params = {
        name: ambassador.name,
        email_address: ambassador.email,
        phone: ambassador.phone
      }
      if (this.isEditMode) {
        params.id = this.ambassadorId
      }
      this.loading = true
      try {
        await saveMethod(params)
        this.handelCancel()
      } finally {
        this.loading = false
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.edit-ambassador-container {
  .header-container {
    font-size: 18px;
    font-weight: 500;
    color: #303133;
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 12px;
  }

  .ambassador-info {
    width: 606px;
    margin: 30px auto 0;
    .body-container {
      margin-top: 20px;

      .item-container {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .label {
          width: 15%;
          text-align: right;
          margin-right: 30px;
          display: inline-block;
        }

        .content {
          flex: 1;
          display: inline-block;

          ::v-deep {
            .el-input__inner {

              height: 32px;
              line-height: 32px;
              border-radius: 0;
            }
            .el-input__icon {
              line-height: 32px;
            }
          }
        }

      }
      .error-tips {
        padding-left: calc(15% + 30px);
        display: block;
        color: red;
      }
    }

    .btn-container {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
    }
  }

}
</style>
